import React, { useEffect, useState, useContext, useRef, useMemo } from 'react'
import Layout from '../Layout'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { useHistory, useLocation } from 'react-router-dom'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import './home.css'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { handleRedirectInternal, mapData } from '../../../Product/common/components'
import { Box, Button, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import Loaders from '../../../Product/components/molecules/Loaders'
import jsonp from 'jsonp'
import AlertContext from '../../../Product/context/alert/alertContext'
import queryString from 'query-string'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import GridProduct from '../../../Component/ProductCard/gridProduct'
import { messageHandler } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import { withStyles } from '@material-ui/core/styles'
import 'swiper/swiper-bundle.css'
import Slider from 'react-slick'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
import FilterPanel from '../../../Product/components/organisms/FilterPanel'
import { useFormik } from 'formik'
import 'react-google-reviews/dist/index.css'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputBase from '@material-ui/core/InputBase'
import Drawer from '@material-ui/core/Drawer'
import CloseIcon from '@material-ui/icons/Close'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import NewsLetter from '../NewsLetter'

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 14,
        padding: '3px 20px 3px 3px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
        },
    },
}))(InputBase)

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    )
}
const settings = {
    dots: false,
    fade: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 10000,
    cssEase: 'linear',
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function BannerBlock({ forMobile, setBannerLoaded }) {
    const isBargain = document.body.className == 'BidAuction bargains'
    // UI Blocks
    return (
        <div className={`${isBargain ? '' : 'customContainer'} bannerContainer mt-3`}>
            {global.multipleBannersFields.length > 1 ? (
                <>
                    {!isBargain ? (
                        !forMobile ? (
                            <div className="siteBanner">
                                <LazyLoadImage
                                    src={
                                        process.env.REACT_APP_AUCTION_IMAGE_URL +
                                        '/' +
                                        global.multipleBannersFields[0].image_name
                                    }
                                    alt={`${global?.storeDetails?.name} banner`}
                                    effect="blur"
                                    height="100%"
                                    onLoad={() => setBannerLoaded(true)}
                                    width="100%"
                                />
                            </div>
                        ) : (
                            <div className="siteBanner">
                                <LazyLoadImage
                                    src={
                                        process.env.REACT_APP_AUCTION_IMAGE_URL +
                                        '/' +
                                        global.multipleBannersFields[1].image_name
                                    }
                                    alt={`${global?.storeDetails?.name} banner`}
                                    effect="blur"
                                    height="100%"
                                    width="100%"
                                    onLoad={() => setBannerLoaded(true)}
                                />
                            </div>
                        )
                    ) : (
                        <div className="siteBanner multiple">
                            <Slider {...settings}>
                                {global.multipleBannersFields?.map((data, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            maxHeight: '400px',
                                            minHeight: '400px',
                                        }}
                                    >
                                        <LazyLoadImage
                                            src={`${process.env.REACT_APP_AUCTION_IMAGE_URL}/${data.image_name}`}
                                            alt={`Banner ${index}`}
                                            effect="blur"
                                            height="100%"
                                            width="100%"
                                            onLoad={() => setBannerLoaded(true)}
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    )}
                </>
            ) : (
                <div className="siteBanner">
                    <LazyLoadImage
                        src={global?.storeDetails?.bannerValue}
                        alt={`${global?.storeDetails?.name} banner`}
                        effect="blur"
                        height="100%"
                        width="100%"
                        onLoad={() => setBannerLoaded(true)}
                    />
                </div>
            )}
        </div>
    )
}

function MobileHomeUI({
    auctionSearch,
    setAuctionSearch,
    isBargainTheme,
    loading,
    viewAuction,
    auctionView,
    setAuctionView,
    handleViewAllItems,
    open,
    handleClickClose,
    formik,
    homeFilterValues,
    pages,
    handleChangePage,
    BootstrapInput,
    setOpen,
    setLoading,
    setViewProduct,
    viewProduct,
    sliderSettings,
    handleClick,
    selectedProduct,
    handleLotClick,
}) {
    return (
        <>
            <div className="sotingBtngrp mb-3 justify-content-start">
                <PrimaryButton
                    label="Current Auctions"
                    className={auctionSearch.auc_type == 2 ? 'active' : ''}
                    onClick={() => {
                        setLoading(true)
                        setAuctionSearch({
                            ...auctionSearch,
                            auc_type: 2,
                            type: '',
                            homepage: 1,
                            orderby: '9',
                        })
                    }}
                />
                <PrimaryButton
                    label="Upcoming Auctions"
                    className={auctionSearch.auc_type == 1 ? 'active' : ''}
                    onClick={() => {
                        setLoading(true)
                        setAuctionSearch({
                            ...auctionSearch,
                            auc_type: 1,
                            type: '',
                            homepage: 1,
                            orderby: '9',
                        })
                    }}
                />
                {!isBargainTheme ? (
                    <PrimaryButton
                        label="Closed Auctions"
                        className={auctionSearch.auc_type == '' ? 'active' : ''}
                        onClick={() => {
                            setLoading(true)
                            setAuctionSearch({
                                ...auctionSearch,
                                auc_type: '',
                                sh_limit: '5',
                                is_auction: 1,
                                type: 'closed',
                                homepage: 1,
                                orderby: '1',
                            })
                        }}
                    />
                ) : (
                    ''
                )}
            </div>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '18px 0px',
                    justifyContent: 'space-between',
                }}
                className="viewItemLst"
            >
                <Button
                    variant="none"
                    color="primary"
                    onClick={handleViewAllItems}
                    style={{
                        padding: '5px 20px',
                        margin: '0px',
                        fontSize: '10px',
                        backgroundColor: '#1f3c77',
                        color: 'white',
                        lineHeight: '1',
                        minWidth: '80px',
                    }}
                >
                    View <br /> All Items
                </Button>
                <div>
                    <Drawer
                        anchor="bottom"
                        open={open}
                        onClose={handleClickClose}
                        sx={{
                            '& .MuiDrawer-paper': {
                                height: '100vh',
                                width: '100vw',
                                padding: '16px',
                            },
                        }}
                        BackdropProps={{
                            style: { backgroundColor: 'transparent' },
                        }}
                    >
                        <Box
                            sx={{
                                height: '70vh',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '24px',
                            }}
                        >
                            <Button
                                aria-label="close"
                                onClick={handleClickClose}
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '5px',
                                }}
                            >
                                <CloseIcon />
                            </Button>
                            <FilterPanel formik={formik} filterValues={homeFilterValues} />
                        </Box>
                    </Drawer>
                </div>
                <div className="gridListToggleActive">
                    <Button
                        className={auctionView === 'Grid' ? 'active' : ''}
                        onClick={() => setAuctionView('Grid')}
                        style={{ padding: '0px', margin: '0px' }}
                    >
                        <span className="material-icons">apps</span>
                        <span style={{ fontSize: '12px' }}>Grid</span>
                    </Button>
                    <Button
                        className={auctionView === 'List' ? 'active' : ''}
                        onClick={() => setAuctionView('List')}
                        style={{ padding: '0px', margin: '0px' }}
                    >
                        <span className="material-icons">view_list</span>
                        <span style={{ fontSize: '12px' }}>List</span>
                    </Button>
                </div>
                <div className="resultShow">
                    <span style={{ fontSize: '12px', fontWeight: '500' }}>Show Results</span>
                    <FormControl>
                        <Select
                            labelId="demo-customized-select-label"
                            id="demo-customized-select"
                            value={pages}
                            onChange={handleChangePage}
                            input={<BootstrapInput />}
                            defaultValue={'15'}
                        >
                            <MenuItem value={15}>15</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <HomeAuctionList
                loading={loading}
                viewAuction={viewAuction}
                auctionView={auctionView}
                handleLotClick={handleLotClick}
                viewProduct={viewProduct}
                sliderSettings={sliderSettings}
                handleClick={handleClick}
                selectedProduct={selectedProduct}
                forMobile={true}
            />
        </>
    )
}

function DesktopHomeUI({
    auctionSearch,
    setAuctionSearch,
    isBargainTheme,
    loading,
    viewAuction,
    auctionView,
    setAuctionView,
    handleLotClick,
    viewProduct,
    sliderSettings,
    handleClick,
    selectedProduct,
    setLoading,
}) {
    return (
        <>
            <div className="sotingBtngrp mb-3 justify-content-start">
                <PrimaryButton
                    label="Current Auctions"
                    className={auctionSearch.auc_type == 2 ? 'active' : ''}
                    onClick={() => {
                        setLoading(true)
                        setAuctionSearch({
                            ...auctionSearch,
                            auc_type: 2,
                            type: '',
                            homepage: 1,
                            orderby: '9',
                        })
                    }}
                />
                <PrimaryButton
                    label="Upcoming Auctions"
                    className={auctionSearch.auc_type == 1 ? 'active' : ''}
                    onClick={() => {
                        setLoading(true)
                        setAuctionSearch({
                            ...auctionSearch,
                            auc_type: 1,
                            type: '',
                            homepage: 1,
                            orderby: '9',
                        })
                    }}
                />
                {!isBargainTheme ? (
                    <PrimaryButton
                        label="Closed Auctions"
                        className={auctionSearch.auc_type == '' ? 'active' : ''}
                        onClick={() => {
                            setLoading(true)
                            setAuctionSearch({
                                ...auctionSearch,
                                sh_limit: '5',
                                auc_type: '',
                                type: 'closed',
                                is_auction: 1,
                                homepage: 1,
                                orderby: '1',
                            })
                        }}
                    />
                ) : (
                    ''
                )}
            </div>
            <HomeAuctionList
                loading={loading}
                viewAuction={viewAuction}
                auctionView={auctionView}
                handleLotClick={handleLotClick}
                viewProduct={viewProduct}
                sliderSettings={sliderSettings}
                handleClick={handleClick}
                selectedProduct={selectedProduct}
                forMobile={false}
            />
        </>
    )
}

function HomeAuctionList({
    loading,
    viewAuction,
    auctionView,
    handleLotClick,
    viewProduct,
    sliderSettings,
    handleClick,
    selectedProduct,
    forMobile,
}) {
    return (
        <div className="homeAuctionList_Root">
            <div className="splEvntsWrpr pb-4">
                <div className="vwActnWrapper">
                    {loading ? (
                        <div className="listSketonLoader">
                            <Loaders
                                isLoading={loading}
                                loop={3}
                                name="product_list_view"
                                theme="BidAuctionDepot"
                            />
                        </div>
                    ) : viewAuction.length ? (
                        <div className="hmActnLstWrpr mb-5">
                            {viewAuction.map((data, index) => (
                                <>
                                    {auctionView === 'Grid' ? (
                                        <MultisellerListCard
                                            data={data}
                                            key={index}
                                            details={`search/product-buyer-auction/${data.id}`}
                                            cardTheme="bidAuction"
                                            handleLotClick={handleLotClick}
                                        />
                                    ) : (
                                        <div className="listViewBid">
                                            <MultisellerListCard
                                                data={data}
                                                key={index}
                                                details={`search/product-buyer-auction/${data.id}`}
                                                cardTheme="bidAuction"
                                                bidList={auctionView}
                                            />
                                        </div>
                                    )}
                                </>
                            ))}
                        </div>
                    ) : (
                        <NoRecordsFound />
                    )}
                    <h2 className="lotsEnding">FEATURED ITEMS</h2>
                    <div className="slider-container">
                        <Slider {...sliderSettings}>
                            {viewProduct.map((data, index) => (
                                <>
                                    {forMobile ? (
                                        <MultisellerListCard
                                            cardTheme="bidAuction"
                                            lotData={data}
                                            viewProduct={viewProduct}
                                            className={data.auction ? 'auction' : 'buynow'}
                                            key={index}
                                            bidStatus={true}
                                            type="lot"
                                            handleClick={handleClick}
                                            details={`/gallery/product-view/${data.id}`}
                                            sliderTheme="multiseller"
                                            card_theme="liquidationTwo"
                                            standalonePage={true}
                                            bidBtnLabel={
                                                <>
                                                    <span className="material-icons-outlined">
                                                        gavel
                                                    </span>
                                                    Bid
                                                </>
                                            }
                                        />
                                    ) : (
                                        <GridProduct
                                            data={data}
                                            viewProduct={viewProduct}
                                            setViewProduct={() => {}}
                                            className={data.auction ? 'auction' : 'buynow'}
                                            key={index}
                                            type={data.auction ? 'auction' : 'buynow'}
                                            selectedProduct={selectedProduct}
                                            link={`/gallery/product-view/${data.id}`}
                                            handleClick={handleClick}
                                            timerTheme=""
                                            bidStatus={true}
                                            sliderTheme="multiseller"
                                            currencyType="usd"
                                            timerIcon={true}
                                            cardTheme="bidAuction"
                                            bidBtnLabel="Place Bid"
                                        />
                                    )}
                                </>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Home = (props) => {
    // Context
    const { user } = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)

    const {
        search_allauctions,
        getAllSearchAuctions,
        search_allproducts,
        getAllSearchProducts,
        clearResponse_search_details,
    } = productContext
    const { setAlert } = alertContext

    // States
    const history = useHistory()
    const location = useLocation()
    const forMobile = useMediaQuery('(max-width:780px)')
    const [loading, setLoading] = useState(true)
    const [viewProduct, setViewProduct] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [viewAuction, setViewAuction] = useState([])
    const [auctionView, setAuctionView] = useState(window.innerWidth < 600 ? 'List' : 'Grid')
    const [pages, setPages] = useState(15)
    const [open, setOpen] = useState(false)
    const [isBannerLoaded, setBannerLoaded] = useState(false)
    const searchbar = useMemo(
        () => new URLSearchParams(window.location.search.substring(1)).get('q'),
        [],
    )
    const catg = useMemo(
        () => new URLSearchParams(window.location.search.substring(1)).get('cat'),
        [],
    )
    const params = useMemo(() => new URLSearchParams(window.location.search.substring(1)), [])
    const isBargainTheme = document.querySelector('body').classList.contains('bargains')

    const formik = useFormik({
        initialValues: {
            sh_limit: sessionStorage.getItem('sh_limit'),
            page: 1,
            orderby: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '15' : '',
            location: [],
            sortType:
                global?.storeConfigration?.liquidation_filter_update?.value == 1 ? 2 : undefined,
            state: [],
            city: [],

            category: catg ? [catg] : [],
            contenthead5: [],
            subcategory: [],
            condition: [],
            storedate: [],
            enddate: null,
            fromprice: 0,
            toprice: 0,
            totalpage: 5,
            lotof: '',
            searchbar: searchbar ? searchbar : '',
            miles: params.get('m') ? params.get('m') : '',
            from: '',
            closed_auction_list: 0,
            view_type: params.get('view') ? params.get('view') : 0,
            auction_io: 1,
            conditionunique: [],
            lotsize: ['1'],

            orderby2: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '' : '6',
            need_bid_increment: 1,
        },
    })

    const [auctionSearch, setAuctionSearch] = useState({
        page: 1,
        sh_limit: '10',
        orderby: '9',
        searchbar: '',
        auc_type: '2',
        type: '',
        auction_io: 1,
        lot_images: 1,
        is_auction: 1,
        homepage: 1,
    })

    const [subLotSearch, setSubLotSearch] = useState({
        auc_type: '2',
        page: 1,
        orderby: global?.storeConfigration?.home_pag_liq_2_changes?.value ? '16' : '2',
        lotof: '',
        sh_limit: 100,
        market_status: 'open',
        auction_io: 1,
        from: global?.storeConfigration?.home_pag_liq_2_changes?.value
            ? 'auction_only'
            : global.storeConfigration?.liq_home_page_changes?.value == 1
            ? undefined
            : 'auction_only',

        type: 'active',
        need_bid_increment: 1,
        featured: 1,
    })

    const homeFilterValues = useMemo(
        () => [
            {
                title: 'Categories',
                type: 'check',
                name: 'category',
                options: global.searchCategories.sort((a, b) =>
                    a.description.localeCompare(b.description),
                ),
                formik: formik,
            },
        ],
        [formik],
    )

    // Refs, hooks
    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    // const sliderSettings = useMemo(
    //     () => ({
    //         dots: true,
    //         className: 'custom-slider',
    //         infinite: viewProduct.length > 4,
    //         speed: 2000,
    //         autoplaySpeed: 3000,
    //         slidesToShow: 4,
    //         slidesToScroll: 4,
    //         arrows: true,
    //         responsive: [
    //             { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    //             { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    //             {
    //                 breakpoint: 480,
    //                 settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 1,
    //                     autoplay: true,
    //                     speed: 500,
    //                     autoplaySpeed: 2000,
    //                     dots: false,
    //                 },
    //             },
    //         ],
    //     }),
    //     [viewProduct.length],
    // )

    const sliderSettings = {
        dots: true,
        className: 'custom-slider',
        infinite: viewProduct.length > 4,
        speed: 1000,
        autoplaySpeed: 2500,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: true,
                    speed: 500,
                    autoplaySpeed: 2000,
                    dots: false,
                },
            },
        ],
    }

    //Sockets
    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }
    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socket.on('buyer_assurance', (data) => {
            handler(data, 'buyer_assurance')
        })

        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('buyer_assurance', (data) => {
                handler(data, 'buyer_assurance')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
        }
    }, [])

    useEffect(() => {
        setLoading(true)
        getAllSearchProducts(subLotSearch, 'activeHome')
    }, [subLotSearch])

    useEffect(() => {
        getAllSearchAuctions(auctionSearch, 'home_page')
    }, [auctionSearch])

    useEffect(() => {
        if (search_allproducts.from === 'activeHome') {
            if (search_allproducts.results.length > 0) {
                search_allproducts.results.map((data) => {
                    if (data?.extra_fields?.includes('}')) {
                        let parse = JSON.parse(data.extra_fields)
                        Object.keys(parse).map((val) => {
                            data[val] = parse[val]
                        })
                    }
                })

                setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            } else {
                setViewProduct([])
            }
            setLoading(false)
            clearResponse_search_details()
        }
    }, [search_allproducts])

    useEffect(() => {
        setViewAuction(search_allauctions?.results?.length ? search_allauctions?.results : [])
        setLoading(false)
    }, [search_allauctions])

    useEffect(() => {
        const scrollToId = location.state?.scrollTo
        if (scrollToId && isBannerLoaded) {
            setTimeout(() => {
                const target = document.getElementById(scrollToId)
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' })
                }
            }, 0)
            if (location.state?.auc_type !== undefined) {
                setLoading(true)
                if (location.state?.auc_type == 1) {
                    setAuctionSearch({
                        ...auctionSearch,
                        auc_type: 1,
                        type: '',
                        orderby: '9',
                        homepage: 1,
                    })
                } else if (location.state?.auc_type == 2) {
                    setAuctionSearch({
                        ...auctionSearch,
                        auc_type: 2,
                        type: '',
                        orderby: '9',
                        homepage: 1,
                    })
                } else {
                    setAuctionSearch({
                        ...auctionSearch,
                        auc_type: '',
                        type: 'closed',
                        orderby: '1',
                        homepage: 1,
                    })
                }
            }
        }
    }, [location.state?.triggerScroll, isBannerLoaded])

    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    // Handlers
    const handleChangePage = (event) => {
        setPages(event.target.value)
    }
    const handleClose = () => setSelectedProduct(null)
    const handleClickClose = () => {
        setOpen(false)
    }
    const handleClick = async (id) => {
        setSelectedProduct(id)
    }
    const handleViewAllItems = (e) => {
        history.push(`/search`)
    }
    const handleLotClick = async (id) => {
        handleRedirectInternal(history, `productView/${id}`)
    }

    // UI
    return (
        <Layout props={props}>
            <NewsLetter />
            <div className="home">
                <BannerBlock forMobile={forMobile} setBannerLoaded={setBannerLoaded} />
                <div className="customContainer" id="customContainer">
                    {forMobile ? (
                        <MobileHomeUI
                            auctionSearch={auctionSearch}
                            setAuctionSearch={setAuctionSearch}
                            isBargainTheme={isBargainTheme}
                            loading={loading}
                            viewAuction={viewAuction}
                            auctionView={auctionView}
                            setAuctionView={setAuctionView}
                            handleViewAllItems={handleViewAllItems}
                            open={open}
                            handleClickClose={handleClickClose}
                            formik={formik}
                            homeFilterValues={homeFilterValues}
                            pages={pages}
                            handleChangePage={handleChangePage}
                            BootstrapInput={BootstrapInput}
                            setOpen={setOpen}
                            setLoading={setLoading}
                            setViewProduct={setViewProduct}
                            viewProduct={viewProduct}
                            sliderSettings={sliderSettings}
                            handleClick={handleClick}
                            selectedProduct={selectedProduct}
                            handleLotClick={handleLotClick}
                        />
                    ) : (
                        <DesktopHomeUI
                            auctionSearch={auctionSearch}
                            setAuctionSearch={setAuctionSearch}
                            isBargainTheme={isBargainTheme}
                            loading={loading}
                            viewAuction={viewAuction}
                            auctionView={auctionView}
                            setAuctionView={setAuctionView}
                            handleLotClick={handleLotClick}
                            viewProduct={viewProduct}
                            sliderSettings={sliderSettings}
                            handleClick={handleClick}
                            selectedProduct={selectedProduct}
                            setLoading={setLoading}
                        />
                    )}
                </div>
            </div>
            <MultisellerSlider
                selectedLot={selectedProduct}
                handleClose={handleClose}
                currency="cad"
                type={props.type ? props.type : ''}
                storeTheme="Liquidation_two"
                pvTabList={true}
            />
        </Layout>
    )
}

export default Home
